export const USERPILOT_NON_COURSE_ADMIN_ID = '';
